module.exports = __webpack_public_path__ + "static/media/profile.980635df.svg";